<template>
  <div :class="_.search">
    <!-- 搜索框区域 -->
    <div :class="_.box" @click="handleSearch">
      <x-icon name="search" :class="_.icon" />

      <span :class="_.text">{{ placeholder }}</span>
    </div>

    <!-- 搜索按钮 -->
    <div :class="_.btn" @click="handleSearch">搜索</div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    name: 'SearchSection',

    props: {
      // 占位符文本
      placeholder: {
        type: String,
        default: '仅搜索适老化相关产品',
      },
    },

    data: () => ({}),

    methods: {
      // 处理搜索
      handleSearch() {
        const { pageType = 0 } = this.$route.query
        this.$router.push({ path: '/slh/search', query: { pageType } })
      },
    },
  })
</script>

<style lang="scss" module>
  .search {
    background-color: #fff;
    display: flex;
    align-items: center;
    padding: 12px 12px 0;

    .box {
      flex: 1;
      display: flex;
      align-items: center;
      min-height: 34px;
      padding: 0 16px;
      background-color: #f5f5f5;
      border-radius: 27px;
      margin-right: 12px;

      .icon {
        flex-shrink: 0;
        font-size: 16px;
        color: #b2b2b2;
        margin-right: 8px;
      }

      .text {
        flex: 1;
        font-size: 14px;
        color: #888;
        appearance: none;
        box-shadow: none;
        border: none;
        border-radius: 0;
        outline: none;
        background-color: transparent;
      }
    }

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 54px;
      height: 28px;
      background: linear-gradient(131deg, #ffbb43 0%, #ff8311 100%);
      color: #fff;
      border-radius: 27px;
      font-size: 14px;
    }
  }
</style>
